import { Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import { PlaybooksTab } from '@/features/activity/components/tabs/playbooks'
import { activityQueries } from '@/features/activity/queries'
import { WORKFLOW_ACTION_STATUS } from '@/features/activity/types'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'

import { getCurrentTenant } from '@/shared/auth/store'
import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

import { ErrorBoundary } from '@/components/common/error-boundary'

const searchSchema = z.object({
	q: z.string().optional(),
	filters: z
		.object({
			status: WORKFLOW_ACTION_STATUS.optional(),
		})
		.optional(),
})

export const Route = createFileRoute('/_dashboard/activity/playbooks')({
	validateSearch: zodValidator(searchSchema),

	loader: async ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant() as string

		if (tenant) {
			await queryClient.ensureInfiniteQueryData(activityQueries.list(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Activity | Playbooks | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	pendingComponent: RoutePendingComponent,
	errorComponent: RouteErrorComponent,
})

/**
 * Playbooks Activity Route
 */
function RouteComponent() {
	return (
		<ErrorBoundary feature="activity" section="playbooks">
			<Suspense
				fallback={<TableFullSkeleton rows={15} withFilters withLastUpdated />}
			>
				<PlaybooksTab />
			</Suspense>
		</ErrorBoundary>
	)
}

/**
 * Loading state for Playbooks Activity
 */
function RoutePendingComponent() {
	return <TableFullSkeleton rows={15} withFilters withLastUpdated />
}
